import { FC, useRef } from 'react';

import { Grid, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import FieldSection from 'src/components/FieldSection';
import CurrencyFieldSuffix from 'src/types/Fields/CurrencyFieldSuffix';
import getValueByPath from 'src/utils/lodashLike/getValueByPath';

import CurrencyField from '../base/currency/CurrencyField';

interface LoanMonthlyPaymentFieldProps {
  name: string;
}

const LoanMonthlyPaymentField: FC<LoanMonthlyPaymentFieldProps> = (props) => {
  const { name } = props;

  const { values, errors, touched } = useFormikContext<{ [key: string]: any; }>();

  const error = getValueByPath<string>(errors, name);
  const isTouched = getValueByPath<boolean>(touched, name);
  const value = getValueByPath<string>(values, name);
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <FieldSection
      description='Total (full) monthly cost'
      spacing={0}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <CurrencyField
          ref={scrollRef}
          value={value}
          name={name}
          error={!!error && isTouched}
          fullWidth
          onFocus={() => { scrollRef.current?.scrollIntoView({ behavior: 'smooth' }); }}
          suffix={CurrencyFieldSuffix.KR_PER_MONTH}
        />
      </Grid>
      {error && isTouched && (
        <Grid
          item
          xs={12}
        >
          <Typography
            variant='caption'
            color="error"
          >
            {error}
          </Typography>
        </Grid>
      )}
    </FieldSection>
  );
};


export default LoanMonthlyPaymentField;
